import { NullableClassName } from '@squareup/dex-types-shared-ui';
import { CodeField } from '@squareup/dex-ui-shared-base';
import { highlight, HighlightLanguage } from '@squareup/dex-utils-highlight';
import clsx from 'clsx';
import React, { FunctionComponent } from 'react';

import styles from './code.module.css';
import prismStyles from './prism.module.css';

interface CodeProps {
  code: string;
  language: HighlightLanguage;
  showLineNumbers?: boolean | undefined;
}

const Code: FunctionComponent<CodeProps & NullableClassName> = ({
  className,
  code,
  language,
  showLineNumbers,
}) => {
  const numLines = code?.split('\n').length || 1;

  // We might have per-language overrides in our CSS
  const languageKey = `language-${language}` as keyof typeof prismStyles;
  const languageClass = prismStyles[languageKey] ?? '';

  return (
    <CodeField
      data-testid="code-block-contents"
      data-line-numbers-active={showLineNumbers}
      style={
        {
          '--line-number-length': `${numLines.toString().length}ch`,
        } as React.CSSProperties
      }
      as={'div'}
      className={clsx(
        styles['code'],
        prismStyles['code-highlight'],
        languageClass,
        showLineNumbers && styles['line-numbers'],
        className
      )}
    >
      {highlight(code, language)}
    </CodeField>
  );
};

export { Code };
